
/**
 * @nullable
 */
export type TweetCreateRequestPoll = {
  /**
   * @minimum 5
   * @maximum 10080
   */
  durationMinutes: number;
  /**
   * @minItems 2
   * @maxItems 4
   */
  options: string[];
} | null;
